<template>
	<div>
		<base-header class="pb-6 bg-light">
			<b-row aling-v="center" class="py-4">
				<b-col cols="7" lg="6">
					<h6 class="h2 d-inline-block mb-0 text-dark">{{ title }}</h6>
				</b-col>
				<b-col cols="5" lg="6" class="text-right">
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</b-col>
			</b-row>
		</base-header>
		<b-container fluid class="mt--6">
			<b-card no-body>
				<b-card-header>
					<span class="h3">Report configuration</span>
				</b-card-header>

				<b-card-body>
					<b-form>
						<b-row>
							<b-col xl="3" md="3"></b-col>
							<b-col xl="6" md="6">
								<b-form-select
									v-model="cordovaReportValue"
									:options="cordovaReportSelect"
									value-field="value"
									text-field="text"
									v-on:change="getPlanSelect"
								></b-form-select>
							</b-col>
							<b-col xl="3" md="3">
								<div class="text-left" v-if="cordovaReportValue !== ''">
									<b-button
										class="btn btn-primary mt-3 mt-lg-0 mt-xl-0 mt-sm-0"
										variant="primary"
										size="md"
									>
										<span v-if="!loadingStatus" v-on:click="runReport">Run Report</span>
										<span v-if="loadingStatus">
											<b-icon icon="circle-fill" animation="throb" font-scale="1"></b-icon>
											Loading...
										</span>
									</b-button>
								</div>
							</b-col>
						</b-row>
						<div class="mt-4" v-if="cordovaReportValue !== ''">
							<b-row class="mt-2" v-if="imeifilterStatus">
								<b-col xl="3" md="3">
									<div class="mt-1 text-left text-lg-right text-md-right text-xl-right">
										<label for="range" class="font-weight-900 text-sm mt-2">IMEISV FILTER</label>
									</div>
								</b-col>
								<b-col xl="6" md="6">
									<b-input type="text" v-model="imeisvFilter"></b-input>
								</b-col>

								<b-col xl="3" md="3"> </b-col>
							</b-row>
							<b-row class="mt-2" v-if="tacFilterStatus">
								<b-col xl="3" md="3">
									<div class="mt-1 text-left text-lg-right text-md-right text-xl-right">
										<label for="range" class="font-weight-900 text-sm mt-2">TAC FILTER</label>
									</div>
								</b-col>
								<b-col xl="6" md="6">
									<b-input type="text" v-model="tacFilter"></b-input>
								</b-col>

								<b-col xl="3" md="3"> </b-col>
							</b-row>
							<b-row class="mt-2" v-if="imeifilterStatus">
								<b-col xl="3" md="3">
									<div class="mt-1 text-left text-lg-right text-md-right text-xl-right">
										<label for="text" class="font-weight-900 text-sm mt-2">IMSI FILTER</label>
									</div>
								</b-col>
								<b-col xl="6" md="6">
									<b-input type="text" v-model="imsiFilter"></b-input>
								</b-col>

								<b-col xl="3" md="3"> </b-col>
							</b-row>
							<b-row v-if="dateRangeStatus">
								<b-col xl="3" md="3">
									<div class="mt-1 text-left text-lg-right text-md-right text-xl-right">
										<label for="range" class="font-weight-900 text-sm mt-2">DATE RANGE:</label>
									</div>
								</b-col>
								<b-col xl="6" md="6">
									<date-range-picker v-model="dateRange" @update="updateValues"> </date-range-picker>
								</b-col>
							</b-row>
							<b-row class="mt-2" v-if="imsiFilterStatus">
								<b-col xl="3" md="3">
									<div class="mt-1 text-left text-lg-right text-md-right text-xl-right">
										<label for="range" class="font-weight-900 text-sm mt-2">IMSI FILTER</label>
									</div>
								</b-col>
								<b-col xl="6" md="6">
									<b-input type="text" v-model="imsiFilter"></b-input>
								</b-col>

								<b-col xl="3" md="3"> </b-col>
							</b-row>
							<b-row class="mt-2" v-if="statusFilterStatus">
								<b-col xl="3" md="3">
									<div class="mt-1 text-left text-lg-right text-md-right text-xl-right">
										<label for="range" class="font-weight-900 text-sm mt-2">STATUS FILTER</label>
									</div>
								</b-col>
								<b-col xl="6" md="6">
									<b-input type="text" v-model="statusFilter"></b-input>
								</b-col>
								<b-col xl="3" md="3"> </b-col>
							</b-row>
							<b-row class="mt-2" v-if="hssNameStatus">
								<b-col xl="3" md="3">
									<div class="mt-1 text-left text-lg-right text-md-right text-xl-right">
										<label for="text" class="font-weight-900 text-sm mt-2"
											>HSS_SUBSCRIBER_NAME FILTER</label
										>
									</div>
								</b-col>
								<b-col xl="6" md="6">
									<b-input type="text" v-model="hssName"></b-input>
								</b-col>
							</b-row>
							<b-row class="mt-2" v-if="imsiStatusStatus">
								<b-col xl="3" md="3">
									<div class="mt-1 text-left text-lg-right text-md-right text-xl-right">
										<label for="range" class="font-weight-900 text-sm mt-2">IMSI STATUS</label>
									</div>
								</b-col>
								<b-col xl="6" md="6">
									<b-input type="text" v-model="imsiStatus"></b-input>
								</b-col>

								<b-col xl="3" md="3"> </b-col>
							</b-row>
							<b-row class="mt-2" v-if="imsiStatusStatus">
								<b-col xl="3" md="3">
									<div class="mt-1 text-left text-lg-right text-md-right text-xl-right">
										<label for="range" class="font-weight-900 text-sm mt-2">HSS_PROFILE</label>
									</div>
								</b-col>
								<b-col xl="6" md="6">
									<b-input type="text" v-model="hssProfile"></b-input>
								</b-col>
								<b-col xl="3" md="3"> </b-col>
							</b-row>
							<b-row class="mt-2" v-if="dateFilterStatus">
								<b-col xl="3" md="3">
									<div class="mt-1 text-left text-lg-right text-md-right text-xl-right">
										<label for="range" class="font-weight-900 text-sm mt-2"
											>START DATE FILTER</label
										>
									</div>
								</b-col>
								<b-col xl="6" md="6">
									<base-input
										class="mb-0"
										v-model="dateFilter"
										type="date"
										id="startDateFilter"
										format="yyyy-mm-dd"
									/>
								</b-col>

								<b-col xl="3" md="3"> </b-col>
							</b-row>

							<b-row class="mt-2" v-if="showStartEnd">
								<b-col xl="3" md="3">
									<div class="mt-1 text-left text-lg-right text-md-right text-xl-right">
										<label for="range" class="font-weight-900 text-sm mt-2">ROW START:</label>
									</div>
								</b-col>
								<b-col xl="6" md="6">
									<b-input type="number" v-model="startRow"></b-input>
								</b-col>

								<b-col xl="3" md="3"> </b-col>
							</b-row>
							<b-row class="mt-2" v-if="showStartEnd">
								<b-col xl="3" md="3">
									<div class="mt-1 text-left text-lg-right text-md-right text-xl-right">
										<label for="range" class="font-weight-900 text-sm mt-2">ROW END:</label>
									</div>
								</b-col>
								<b-col xl="6" md="6">
									<b-input type="number" v-model="endRow"></b-input>
								</b-col>

								<b-col xl="3" md="3"> </b-col>
							</b-row>
						</div>
					</b-form>

					<hr />

					<transition name="slide-fade">
						<div>
							<div class="text-center w-100" v-if="loadingStatus">
								<p class="text-primary">
									Your report is running. This report usually takes 0.03 seconds.
								</p>
								<b-icon icon="three-dots" class="text-center" animation="cylon" font-scale="4"></b-icon>
							</div>
							<div v-if="!loadingStatus && !displayStatus">
								<div class="cursor-pointer">
									<p v-b-toggle.accordion-1 class="text-info">Show time estimate data</p>
									<b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
										<small><b>Number of Samples</b>: 11</small><br />
										<small><b>Minimum Time</b>: 0.01</small><br />
										<small><b>Maximum Time</b>: 0.1</small><br />
										<small><b>Median</b>: 0.03</small><br />
										<small><b>Average</b>: 0.04</small><br />
										<small><b>Standard Deviation</b>: 0.03</small><br />
									</b-collapse>
								</div>
							</div>
							<div class="mb-3" v-if="!loadingStatus && displayStatus">
								<b-row>
									<b-col lg="7" class="d-lg-flex d-xl-flex">
										<div class="d-flex">
											<label id="filter-input" class="mt-1 mr-3">Search: </label>
											<b-form-group
												label=""
												label-for="filter-input"
												label-align-sm="right"
												label-size="sm"
												class="mb-0"
											>
												<b-input-group size="sm">
													<b-form-input
														id="filter-input"
														v-model="filter"
														placeholder="Search..."
														class="custom-search-box"
													></b-form-input>
												</b-input-group>
											</b-form-group>
										</div>
										<div class="ml-md-3 ml-lg-3 mt-1 mb-2">Showing {{ totalRows }} entries</div>
									</b-col>
									<b-col lg="5" class="flex" v-if="totalRows > 0">
										<div class="d-flex float-right mb-3">
											<b-dropdown text="Download/show as" variant="success" class="mr-2">
												<vue-json-to-csv :json-data="tableData" :csv-title="title">
													<b-dropdown-item href="#"
														>Comma Separated Values (*.csv)</b-dropdown-item
													></vue-json-to-csv
												>
												<download-excel :data="tableData" :name="title">
													<b-dropdown-item href="#"
														>Excel (*.xls)</b-dropdown-item
													></download-excel
												>
												<b-dropdown-item href="#" v-on:click="textDownload"
													>Text (*.txt)</b-dropdown-item
												>
												<b-dropdown-divider></b-dropdown-divider>
												<b-dropdown-item href="#" v-on:click="jsonDownload"
													>JSON (*.json)</b-dropdown-item
												>
												<b-dropdown-item href="#" v-on:click="xmlDownload"
													>XML (*.xml)</b-dropdown-item
												>
											</b-dropdown>
											<b-button variant="danger" v-b-modal.email-report>Email Report</b-button>
										</div>
									</b-col>
								</b-row>

								<div class="primary-table">
									<b-table
										:items="tableData"
										:fields="tableColumns"
										:filter="filter"
										:filter-included-fields="filterOn"
										:sort-by.sync="sortBy"
										:sort-desc.sync="sortDesc"
										:current-page="currentPage"
										:per-page="perPage"
										table-class="text-nowrap"
										sticky-header="true"
										class="data-management-table"
										head-row-variant="primary"
										show-empty
										striped
										hover
										responsive
									>
									</b-table>

									<b-row class="mt-4">
										<b-col> </b-col>
										<b-col xl="auto" md="auto" sm="auto ">
											<b-pagination
												v-model="currentPage"
												:total-rows="totalRows"
												:per-page="perPage"
												aria-controls="inventoryTable"
											></b-pagination>
										</b-col>
									</b-row>
								</div>
							</div>
						</div>
					</transition>
				</b-card-body>
			</b-card>
		</b-container>

		<b-modal centered size="lg" id="email-report" hide-footer title="Email Report">
			<EmailReport :text="title" :url="url"></EmailReport>
		</b-modal>
	</div>
</template>

<script>
import reportsDashboardService from "@/common/api-services/reports-dashboard-service";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import ExportReport from "../../Components/Export-Report";
import configDirective from "../../../common/directive/config-directive";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import VueJsonToCsv from "vue-json-to-csv";
import downloadExcel from "vue-json-excel";
import formatType from "../../../common/format/format-type";
import formatDatetime from "../../../common/format/format-datetime";
import EmailReport from "../../Components/Email-Report";

export default {
	name: "RptTemplate",
	components: {
		ExportReport,
		RouteBreadCrumb,
		DateRangePicker,
		VueJsonToCsv,
		downloadExcel,
		EmailReport,
	},
	data() {
		return {
			title: "",
			cordovaReportSelect: [],
			cordovaReportValue: "",
			dateRange: {
				startDate: formatDatetime.getToday(),
				endDate: formatDatetime.getToday(),
			},
			startRow: 0,
			endRow: 10000,
			tacFilter: "%",
			imeisvFilter: "%",
			imsiFilter: "%",
			hssName: "%",
			statusFilter: "%",
			imsiStatus: "Active",
			hssProfile: "LTE_FAST_IMS",
			dateFilter: formatDatetime.getLastYearMonth(),
			loadingStatus: false,
			displayStatus: false,
			totalRows: 1,
			currentPage: 1,
			perPage: 15,
			tableColumns: [],
			tableData: [],
			allColumns: [],
			sortBy: "",
			sortDesc: false,
			sortDirection: "asc",
			filter: null,
			filterOn: [],
			url: "",
			dateRangeStatus: false,
			showStartEnd: false,
			tacFilterStatus: false,
			imeifilterStatus: false,
			dateFilterStatus: false,
			hssNameStatus: false,
			hssProfileStatus: false,
			imsiStatusStatus: false,
			imsiFilterStatus: false,
			statusFilterStatus: false,
		};
	},
	mounted() {
		document.title = "Cordava Reports";
		let config = configDirective.getConfigData();
		if (!config || config.length < 25) {
			this.$router.push({name: "login"});
			sessionStorage.clear();
		}

		this.loadCordovaReportList();
		this.loadCordovaReportColumn();
	},
	methods: {
		loadCordovaReportList() {
			let data = configDirective.getCordovaReportsList();
			this.cordovaReportSelect = data;
		},

		loadCordovaReportColumn() {
			this.allColumns = configDirective.getCordovaConfigColumn();
		},

		getPlanSelect() {
			this.displayStatus = false;
			let columnVal = "";
			if (this.cordovaReportValue === "imsi_list/ims_status.sql") {
				columnVal = "IMS Status";
				this.title = "IMS Status";
			} else {
				this.cordovaReportSelect.map(item => {
					item.options.map(it => {
						if (it.value === this.cordovaReportValue) {
							if (JSON.stringify(it).includes("MOBILE")) {
								columnVal = it.text;
								this.title = it.text;
							} else {
								columnVal = item.label;
								this.title = it.text;
							}
						}
					});
				});
			}
			this.dateRange.startDate = formatDatetime.getToday();
			this.endRow = 10000;
			this.imsiFilter = "%";
			switch (this.cordovaReportValue) {
				case "data_usage_cdr/data_usage_by_day.sql":
					this.imeifilterStatus = false;
					this.dateFilterStatus = false;
					this.dateRangeStatus = true;
					this.showStartEnd = false;
					this.tacFilterStatus = false;
					this.imsiFilterStatus = false;
					this.hssNameStatus = false;
					this.imsiStatusStatus = false;
					this.hssProfileStatus = false;
					this.statusFilterStatus = false;
					break;
				case "data_usage_cdr/data_usage.sql":
					this.imeifilterStatus = false;
					this.dateFilterStatus = false;
					this.dateRangeStatus = true;
					this.showStartEnd = true;
					this.tacFilterStatus = false;
					this.imsiFilterStatus = false;
					this.hssNameStatus = false;
					this.imsiStatusStatus = false;
					this.hssProfileStatus = false;
					this.statusFilterStatus = false;
					this.dateRange.startDate = formatDatetime.getLastMonthDay();
					break;
				case "tac_list/tac_list.sql":
					this.imeifilterStatus = false;
					this.dateFilterStatus = false;
					this.dateRangeStatus = false;
					this.tacFilterStatus = true;
					this.showStartEnd = true;
					this.imsiFilterStatus = false;
					this.hssNameStatus = false;
					this.imsiStatusStatus = false;
					this.hssProfileStatus = false;
					this.statusFilterStatus = false;
					break;
				case "tac_list/tac_list_total.sql":
					this.imeifilterStatus = false;
					this.dateFilterStatus = false;
					this.dateRangeStatus = false;
					this.tacFilterStatus = true;
					this.showStartEnd = false;
					this.imsiFilterStatus = false;
					this.hssNameStatus = false;
					this.imsiStatusStatus = false;
					this.hssProfileStatus = false;
					this.statusFilterStatus = false;
					break;
				case "imeisv_list/imeisv_list.sql":
					this.imeifilterStatus = true;
					this.dateFilterStatus = true;
					this.dateRangeStatus = false;
					this.tacFilterStatus = false;
					this.showStartEnd = true;
					this.imsiFilterStatus = false;
					this.hssNameStatus = false;
					this.imsiStatusStatus = false;
					this.hssProfileStatus = false;
					this.statusFilterStatus = false;
					this.endRow = 1000;
					break;
				case "imeisv_list/imeisv_list_total.sql":
					this.imeifilterStatus = true;
					this.dateFilterStatus = true;
					this.dateRangeStatus = false;
					this.tacFilterStatus = false;
					this.showStartEnd = false;
					this.imsiFilterStatus = false;
					this.hssNameStatus = false;
					this.imsiStatusStatus = false;
					this.hssProfileStatus = false;
					this.statusFilterStatus = false;
					break;
				case "ims_report/ims_report.sql":
					this.imeifilterStatus = false;
					this.dateFilterStatus = false;
					this.dateRangeStatus = false;
					this.tacFilterStatus = false;
					this.showStartEnd = false;
					this.imsiFilterStatus = true;
					this.hssNameStatus = true;
					this.imsiStatusStatus = true;
					this.hssProfileStatus = true;
					this.statusFilterStatus = false;
					break;
				case "imsi_list/ims_status.sql":
					this.imeifilterStatus = false;
					this.dateFilterStatus = false;
					this.dateRangeStatus = false;
					this.tacFilterStatus = false;
					this.showStartEnd = false;
					this.imsiFilterStatus = true;
					this.hssNameStatus = true;
					this.imsiStatusStatus = false;
					this.hssProfileStatus = false;
					this.statusFilterStatus = false;
					break;
				case "imsi_list/imsi_list.sql":
					this.imeifilterStatus = false;
					this.dateFilterStatus = false;
					this.dateRangeStatus = false;
					this.tacFilterStatus = false;
					this.showStartEnd = true;
					this.imsiFilterStatus = true;
					this.hssNameStatus = true;
					this.imsiStatusStatus = false;
					this.hssProfileStatus = false;
					this.statusFilterStatus = true;
					this.endRow = 1000;
					break;
				case "imsi_list/imsi_list_total.sql":
					this.imeifilterStatus = false;
					this.dateFilterStatus = false;
					this.dateRangeStatus = false;
					this.tacFilterStatus = false;
					this.showStartEnd = false;
					this.imsiFilterStatus = true;
					this.hssNameStatus = true;
					this.imsiStatusStatus = false;
					this.hssProfileStatus = false;
					this.statusFilterStatus = true;
					break;
				case "mobile_data_usage/mobile_data_usage_by_day.sql":
					this.imeifilterStatus = false;
					this.dateFilterStatus = false;
					this.dateRangeStatus = true;
					this.tacFilterStatus = false;
					this.showStartEnd = true;
					this.imsiFilterStatus = true;
					this.hssNameStatus = false;
					this.imsiStatusStatus = false;
					this.hssProfileStatus = false;
					this.statusFilterStatus = false;
					this.dateRange.startDate = formatDatetime.getLastMonthDay();
					this.imsiFilter = "";
					break;
				case "mobile_data_usage/mobile_data_usage.sql":
					this.imeifilterStatus = false;
					this.dateFilterStatus = false;
					this.dateRangeStatus = true;
					this.tacFilterStatus = false;
					this.showStartEnd = true;
					this.imsiFilterStatus = true;
					this.hssNameStatus = false;
					this.imsiStatusStatus = false;
					this.hssProfileStatus = false;
					this.statusFilterStatus = false;
					this.dateRange.startDate = formatDatetime.getLastMonthDay();
					this.imsiFilter = "";
					break;
				default:
					break;
			}
			this.getColumn(columnVal);
		},

		getColumn(header) {
			this.tableColumns = [];
			let data = this.allColumns[header];
			Object.keys(data).forEach(key => {
				let item = {key: key, label: key, sortable: true};
				this.tableColumns.push(item);
			});
		},

		updateValues(val) {
			this.dateRange.startDate = val.startDate;
			this.dateRange.endDate = val.endDate;
		},

		runReport() {
			this.loadingStatus = true;
			this.urlGenerate();
			reportsDashboardService.getCordovaReportData(this.url).then(res => {
				this.loadingStatus = false;
				this.displayStatus = true;
				if (res && res.data) {
					this.tableData = res.data;
				} else {
					this.tableData = [];
				}
				this.totalRows = res.data.length;
			});
		},

		urlGenerate() {
			let sd = new Date(this.dateRange.startDate).toLocaleDateString("en-CA") + "+00:00:00";
			let ed = new Date(this.dateRange.endDate).toLocaleDateString("en-CA") + "+23:59:59";
			let dataUrl = `${encodeURIComponent("Cordova/" + this.cordovaReportValue)}`;
			let hssName = `&${encodeURIComponent("macros[hss_subscribername_filter]")}=${encodeURIComponent(
				this.hssName
			)}`;
			let imsiStatus = `&${encodeURIComponent("macros[imsi_staus]")}=${encodeURIComponent(this.imsiStatus)}`;
			let imsi = `&${encodeURIComponent("macros[imsi]")}=${encodeURIComponent(this.imsiFilter)}`;
			let hssProfile = `&${encodeURIComponent("macros[hss_profile_filter]")}=${encodeURIComponent(
				this.hssProfile
			)}`;
			let tac = `&${encodeURIComponent("macros[tac_filter]")}=${encodeURIComponent(this.tacFilter)}`;
			let startDate = `&${encodeURIComponent("macros[range][start]")}=${encodeURIComponent(sd)}`;
			let endDate = `&${encodeURIComponent("macros[range][end]")}=${encodeURIComponent(ed)}`;
			let startRow = `&${encodeURIComponent("macros[start]")}=${encodeURIComponent(this.startRow)}`;
			let endRow = `&${encodeURIComponent("macros[end]")}=${encodeURIComponent(this.endRow)}`;
			let imeisvFilter = `&${encodeURIComponent("macros[imeisv_filter]")}=${encodeURIComponent(
				this.imeisvFilter
			)}`;
			let imsiFilter = `&${encodeURIComponent("macros[imsi_filter]")}=${encodeURIComponent(this.imsiFilter)}`;
			let dateFilter = `&${encodeURIComponent("macros[auth_filter]")}=${encodeURIComponent(this.dateFilter)}`;
			let statusFilter = `&${encodeURIComponent("macros[status_filter]")}=${encodeURIComponent(
				this.statusFilter
			)}`;

			switch (this.cordovaReportValue) {
				case "data_usage_cdr/data_usage_by_day.sql":
					this.url = dataUrl + startDate + endDate;
					break;
				case "data_usage_cdr/data_usage.sql":
					this.url = dataUrl + startDate + endDate + startRow + endRow;
					break;
				case "tac_list/tac_list.sql":
					this.url = dataUrl + tac + startRow + endRow;
					break;
				case "tac_list/tac_list_total.sql":
					this.url = dataUrl + tac;
					break;
				case "imeisv_list/imeisv_list.sql":
					this.url = dataUrl + imeisvFilter + imsiFilter + dateFilter + startRow + endRow;
					break;
				case "imeisv_list/imeisv_list_total.sql":
					this.url = dataUrl + imeisvFilter + imsiFilter + dateFilter;
					break;
				case "ims_report/ims_report.sql":
					this.url = dataUrl + imsiFilter + hssName + imsiStatus + hssProfile;
					break;
				case "imsi_list/ims_status.sql":
					this.url = dataUrl + imsiFilter + hssName;
					break;
				case "imsi_list/imsi_list.sql":
					this.url = dataUrl + imsiFilter + statusFilter + hssName + startRow + endRow;
					break;
				case "imsi_list/imsi_list_total.sql":
					this.url = dataUrl + imsiFilter + statusFilter + hssName;
					break;
				case "mobile_data_usage/mobile_data_usage_by_day.sql":
					this.url = dataUrl + startDate + endDate + imsi + startRow + endRow;
					break;
				case "mobile_data_usage/mobile_data_usage.sql":
					this.url = dataUrl + startDate + endDate + imsi + startRow + endRow;
					break;
				default:
					break;
			}
		},

		textDownload() {
			formatType.jsonToText(this.tableData, this.title + ".txt");
		},
		jsonDownload() {
			formatType.jsonToJson(this.tableData, this.title + ".json");
		},
		xmlDownload() {
			formatType.jsonToXml(this.tableData, this.title);
		},
	},
	watch: {},
};
</script>
